/**
 * Shared utilities for FrugalNick finance calculators.
 */

export function formatCurrency(amount: number, decimals = 0): string {
  return new Intl.NumberFormat('en-CA', {
    style: 'currency',
    currency: 'CAD',
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(amount);
}

export function formatPercent(rate: number, decimals = 1): string {
  return `${(rate * 100).toFixed(decimals)}%`;
}

export function parseNumber(value: string | number | null, fallback = 0): number {
  const n = Number(value);
  return Number.isFinite(n) ? n : fallback;
}

export function getQueryParams<T extends Record<string, string>>(
  defaults: T,
): T {
  const params = new URLSearchParams(window.location.search);
  const result = { ...defaults };
  for (const key of Object.keys(defaults) as Array<keyof T>) {
    if (params.has(String(key))) {
      result[key] = params.get(String(key)) as T[keyof T];
    }
  }
  return result;
}

export function updateQueryParams(values: Record<string, string | number | boolean>): void {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(values)) {
    if (value !== '' && value !== null && value !== undefined) {
      params.set(key, String(value));
    }
  }
  const query = params.toString();
  const url = `${window.location.pathname}${query ? `?${query}` : ''}`;
  window.history.replaceState({}, '', url);
}

export function copyShareableUrl(
  values: Record<string, string | number | boolean>,
): Promise<void> {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(values)) {
    if (value !== '' && value !== null && value !== undefined) {
      params.set(key, String(value));
    }
  }
  const url = `${window.location.origin}${window.location.pathname}?${params.toString()}`;
  return navigator.clipboard.writeText(url);
}
